import axios from 'axios'

let httpMethods = {
    postMethod : async (payload,url,callback,isAuth=true)=>{
        let options = {
            method: 'POST',
            url,
            timeout: 1000 * 5 * 60,
            headers:{
                "Content-Type": "application/json",
                "x-api-key": "ysCodxpwXk90WH4Gzc0Zp4I4sRiTfKQU7lDFyvwu"
            },
            data:payload
        }
        return await axios(options).then(response=>{
            callback(response)
        }).catch(e=>{
            callback(e)
        })
    }
}


export default httpMethods